import axios from "axios";

export default {
  namespaced: true,
  state: {
    currencyrates: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    currencyratesMessage: ''
  },
  mutations: {
    RECEIVED_CURRENCY_RATES(state, payload) {
      state.currencyrates = payload;
      state.isReceiving = false;
    },
    RECEIVING_CURRENCY_RATES(state) {
      state.isReceiving = true;
    },
    RECEIVED_CURRENCY_RATE(state, payload) {
      state.isReceiving = false;
      let find = state.currencyrates.find(i=>i._id==payload._id);
      if(find==null){
        state = Object.assign(state, { currencyrates: [payload, ...state.currencyrates] });
      }
      else {
        let index = state.currencyrates.findIndex(x => x._id === payload._id);
        state.currencyrates.splice(index, 1, payload);
      }
    },
    RECEIVING_CURRENCY_RATE(state) {
      state.isReceiving = true;
    },
    UPDATED_CURRENCY_RATE(state, payload) {
      let index = state.currencyrates.findIndex(currencyrate => currencyrate._id === payload._id);
      state = Object.assign(state, {
        currencyrates: state.currencyrates.map((currencyrate, i) => {
          if (i === index) {
            return Object.assign({}, currencyrate, payload);
          }
          return currencyrate;
        }),
        isUpdating: false,
        currencyratesMessage: 'CurrencyRates has been updating!',
      })
    },
    UPDATING_CURRENCY_RATE(state) {
      state.isUpdating = true;
    },
    DELETED_CURRENCY_RATE(state, payload) {
      let indexToDelete = state.currencyrates.findIndex(currencyrate => currencyrate._id === payload._id);
      let currencyrates = [...state.currencyrates];
      currencyrates.splice(indexToDelete, 1);
      state = Object.assign(state, {
        currencyrates: [...currencyrates],
        isDeleting: false,
        idToDelete: null,
        currencyratesMessage: 'CurrencyRate has been Deleted!',
      });
    },
    DELETING_CURRENCY_RATE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteCurrencyRateRequest({dispatch}, payload) {
      try{
        dispatch("deletingCurrencyRate", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/currencyrate/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteCurrencyRate", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getCurrencyRatesRequest({dispatch}) {
      dispatch("receivingCurrencyRates");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/currencyrates';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        console.log(res.data);
        dispatch("receiveCurrencyRates", res.data);
      })
    },
    async insertCurrencyRateRequest({dispatch}, payload) {
      dispatch("receivingCurrencyRate");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/currencyrate';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveCurrencyRate", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async updateCurrencyRateRequest({dispatch}, payload) {
      try{
        dispatch("receivingCurrencyRate");
        let token = localStorage.getItem('token');
        let id = payload._id;
        delete payload['_id'];
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/currencyrate/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receiveCurrencyRate", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveCurrencyRates({commit}, payload) {
      commit("RECEIVED_CURRENCY_RATES", payload)
    },
    receivingCurrencyRates({commit}) {
      commit("RECEIVING_CURRENCY_RATES")
    },
    receiveCurrencyRate({commit}, payload) {
      commit("RECEIVED_CURRENCY_RATE", payload)
    },
    receivingCurrencyRate({commit}) {
      commit("RECEIVING_CURRENCY_RATE")
    },
    updateCurrencyRate({commit}, payload) {
      commit("UPDATED_CURRENCY_RATE", payload)
    },
    updatingCurrencyRate({commit}) {
      commit("UPDATING_CURRENCY_RATE")
    },
    deleteCurrencyRate({commit}, payload) {
      commit("DELETED_CURRENCY_RATE", payload)
    },
    deletingCurrencyRate({commit}, payload) {
      commit("DELETING_CURRENCY_RATE", payload)
    }
  },
};
